import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router'
import {useQuery} from 'react-query'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {getPersonaById} from '../../../../modules/services/persona.service'
import {getBreadCrumbs} from '../../breadcrumbs'

const PersonaDetailPage = () => {
  const {id} = useParams<{id: string}>()
  const {data} = useQuery(['getPersonaById', id], () => getPersonaById(id))

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Persona List - {data?.attributes.name}</p>
          </div>
        </div>
      </div>
    </>
  )
}

const PersonaDetailWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('self-care-plan/personadetail')}>
        {intl.formatMessage({id: 'MENU.PERSONA'})}
      </PageTitle>
      <PersonaDetailPage />
    </>
  )
}

export default PersonaDetailWrapper
